import { cdnURL } from 'utils/helpers';

export const LandingPageBackground = [
  {
    filename: 'landingpage_banner.png',
    image_url: cdnURL('quiz_card.png')
  }
];
